import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Bullseye, Spinner } from '@patternfly/react-core';
import { AuthProvider } from './context/AuthContext';
import { BoxProvider } from './context/BoxContext';
import { ThemeProvider } from './context/ThemeContext';
import { routes } from './routes';
import './app.css';

const router = createBrowserRouter(routes);

const App: React.FC = () => (
  <ThemeProvider>
    <AuthProvider>
      <BoxProvider>
        <Suspense
          fallback={
            <Bullseye>
              <Spinner />
            </Bullseye>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
      </BoxProvider>
    </AuthProvider>
  </ThemeProvider>
);

export default App;
